import { useBrand } from "@/brand";

const HERO_IMG = "/images/hero-familie.jpg";

const Hero = () => {
  const brand = useBrand();
  return (
  <section
    id="hero"
    className="relative min-h-[88vh] flex items-center justify-center overflow-hidden bg-[#0B132B] text-white"
    data-testid="hero-section"
  >
    <div className="absolute inset-0">
      <img
        src={HERO_IMG}
        alt="Høyspentmaster i norsk skumringslandskap"
        className="w-full h-full object-cover opacity-60"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B] via-[#0B132B]/65 to-[#0B132B]/40" />
      <div className={`absolute inset-0 ${brand.heroGlow}`} />
    </div>

    <div className="relative max-w-5xl mx-auto px-6 py-28 text-center animate-entry">
      <h1 className="font-serif-heading text-4xl sm:text-6xl md:text-7xl font-bold tracking-tight text-white mb-6 leading-[1.1]">
        Strøm på dine vilkår
      </h1>
      <p className="max-w-2xl mx-auto text-lg sm:text-xl text-slate-200 font-normal leading-relaxed mb-4">
        Ingen binding. Ingen oppsigelse. Ingen påslag.
      </p>
      <p className="max-w-2xl mx-auto text-base sm:text-lg text-slate-300 font-normal leading-relaxed mb-10">
        Strøm til innkjøpspris for deg hjemme – og smart prissikring for bedriften.
        Hos {brand.name} får både privatkunder og bedrifter en enklere strømhverdag.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 max-w-xl mx-auto">
        <a
          href="/bli-kunde"
          className="w-full sm:w-auto px-8 py-4 rounded-md bg-emerald-500 hover:bg-emerald-400 text-[#0B132B] font-bold text-base transition-colors shadow-lg text-center"
          data-testid="hero-cta-button"
        >
          Bli kunde nå
        </a>
        <a
          href="#avtaler"
          className="w-full sm:w-auto px-8 py-4 rounded-md bg-white/10 hover:bg-white/20 border border-white/25 text-white font-semibold text-base transition-colors text-center"
          data-testid="hero-business-button"
        >
          For bedrifter – se Flexsikring
        </a>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 grid grid-cols-2 sm:grid-cols-4 gap-6 text-left">
        <div className="border-l-2 border-emerald-400/60 pl-4">
          <div className="text-2xl font-bold text-white tracking-tight" data-testid="hero-stat-markup">0 øre</div>
          <div className="text-xs text-slate-400 mt-1">Påslag per kWh</div>
        </div>
        <div className="border-l-2 border-emerald-400/60 pl-4">
          <div className="text-2xl font-bold text-white tracking-tight" data-testid="hero-stat-monthly">49 kr</div>
          <div className="text-xs text-slate-400 mt-1">Fast månedsavgift</div>
        </div>
        <div className="border-l-2 border-emerald-400/60 pl-4">
          <div className="text-2xl font-bold text-emerald-400 tracking-tight" data-testid="hero-stat-binding">Ingen</div>
          <div className="text-xs text-slate-400 mt-1">Bindingstid</div>
        </div>
        <div className="border-l-2 border-emerald-400/60 pl-4">
          <div className="text-2xl font-bold text-emerald-400 tracking-tight" data-testid="hero-stat-cancel">Ingen</div>
          <div className="text-xs text-slate-400 mt-1">Oppsigelsesgebyr</div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default Hero;
